<template>
  <div class="admin-tab">
    <wb-datatable
      v-bind="tableProps"
      @addEmit="openCreateDialog"
      @editEmit="openUpdateDialog"
      @deleteEmit="openConfirmDialog"
      :searchKey="'email'"
    ></wb-datatable>

    <md-dialog ref="updateDialog">
      <md-dialog-title>Update User Teams</md-dialog-title>
      <md-dialog-content style="height: 1024px">
        <div v-if="user">
          <div class="teams-list">
            <p>User name</p>
            {{ user.username }}
          </div>
          <div class="teams-list">
            <p>Email</p>
            {{ user.email }}
          </div>
          <div class="teams-list" v-if="user.team">
            <p>Team:</p>
            {{ user.team }}
          </div>
          <md-input-container class="md-has-value">
            <label>Expired Date</label>
            <date-picker
              v-model="selectedDate"
              name="uniquename"
              :clear-button="true"
            >
            </date-picker>
          </md-input-container>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeUpdateDialog(false)"
          >Cancel</md-button
        >
        <md-button class="md-primary" @click="closeUpdateDialog(true)"
          >Update</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog ref="confirmDialog">
      <md-dialog-title
        >Are you sure you want to remove this user from the assigned
        team?</md-dialog-title
      >

      <md-dialog-content>
        <form v-if="user">
          <div class="teams-list">
            <p>User name</p>
            {{ user.username }}
          </div>
          <div class="teams-list">
            <p>Email</p>
            {{ user.email }}
          </div>
          <div class="teams-list">
            <p>Email</p>
            {{ user.team }}
          </div>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeConfirmDialog(false)"
          >Cancel</md-button
        >
        <md-button class="md-primary" @click="closeConfirmDialog(true)"
          >Delete</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-dialog ref="createDialog">
      <md-dialog-title>Create team assignment</md-dialog-title>
      <md-dialog-content style="height: 1024px">
        <div>
          <md-input-container>
            <multiselect
              id="users"
              v-model="selectedUser"
              :options="usersCopy"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              placeholder="Email"
              label="email"
            >
            </multiselect>
          </md-input-container>
          <md-checkbox v-model="allTeams" class="all-teams-checkbox">
            Assign to all teams
          </md-checkbox>
          <md-input-container class="mt-0 pt-0">
            <multiselect
              :disabled="allTeams"
              id="teamName"
              v-model="selectedTeam"
              :options="userTeams"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              placeholder="Team"
              label="name"
            >
            </multiselect>
          </md-input-container>
          <md-input-container class="md-has-value">
            <label>Expired Date</label>
            <date-picker
              v-model="selectedDate"
              name="uniquename"
              :clear-button="true"
            >
            </date-picker>
          </md-input-container>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog(false)"
          >Cancel</md-button
        >
        <md-button class="md-primary" @click="closeDialog(true)">{{
          isNew ? "Create" : "Update"
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import wbDataTable from "WBDataTable";
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import _ from "underscore";
import Multiselect from "vue-multiselect";
import managedata from "../../helpers/managedata";
import utils from "../../helpers/utils";
import DatePicker from "vuejs-datepicker";

export default {
  name: "AdminUsers",
  components: {
    "wb-datatable": wbDataTable,
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      selectedDate: undefined,
      selectedTeam: undefined,
      selectedUser: null,
      isNew: false,
      usersCopy: [],
      oldTeam: null,
      adminTeams: null,
      userTeams: [],
      teamsForAssignments: null,
      newTeam: null,
      user: null,
      userOptions: [],
      tableProps: {
        dataext: [],
        columns: null,
        hasControls: true,
        allowCreation: true,
        disableSearch: false,
        pagination: {
          size: 50,
        },
      },
      allTeams: false,
      appsCopy: [],
      selectedApp: null,
      errorMessage: "",
      isNew: false,
    };
  },
  computed: {
    ...mapGetters(["userTeamAssignments", "teams", "users"]),
  },
  methods: {
    getTeams() {
      this.$store.dispatch("getTeams");
    },
    getUsers() {
      this.$store
        .dispatch("getUsers")
        .then(() => {
          return this.$store.dispatch("getUserTeamAssignments");
        })
        .then(() => {
          this.$store.commit("START_REQUEST");
          const clonedUsers = JSON.parse(JSON.stringify(this.users));
          const bucket = [];
          this.userTeamAssignments.forEach((element) => {
            clonedUsers.forEach((userElement) => {
              if (element.userId === userElement.id) {
                element.userId = userElement.id;
                element.name = userElement.name;
                element.username = userElement.username;
                element.email = userElement.email;

                const teamObj = this.teams.find(
                  (value) => value.id === element.teamId
                );

                if (teamObj) {
                  element.team = teamObj.name;
                }

                if (element.teamId === "*") {
                  element.team = "All Teams";
                }

                element.expiredDate = utils.formatDate(element.expiresAt);
                bucket.push(element);
              }
            });
          });
          this.tableProps.dataext = [];
          this.$nextTick(() => {
            this.tableProps.dataext = bucket;
            this.fillColumns();
          });
          this.$store.commit("FINISH_REQUEST");

          this.$store.dispatch("getUsers").then(() => {
            this.usersCopy = JSON.parse(JSON.stringify(this.users));
            this.usersCopy = _.sortBy(this.usersCopy, function (o) {
              return o.email.toLowerCase();
            });
          });

          this.$store.dispatch("getTeams").then(() => {
            this.userTeams = JSON.parse(JSON.stringify(this.teams));
            this.userTeams = _.sortBy(this.userTeams, function (o) {
              return o;
            });
          });
        });
    },
    fillColumns() {
      let columns = [
        {
          name: "id",
          displayName: "ID",
          visible: true,
          type: "number",
          isEditable: false,
        },
        {
          name: "name",
          displayName: "Name",
          visible: true,
          type: "string",
          isEditable: false,
        },
        {
          name: "username",
          displayName: "Username",
          visible: true,
          type: "string",
          isEditable: false,
        },
        {
          name: "email",
          displayName: "Email",
          visible: true,
          type: "string",
          isEditable: false,
        },
        {
          name: "team",
          displayName: "Team",
          visible: true,
          type: "cellTemplate",
          isEditable: false,
          filterByValue: (a) => (a.teamId == "*" ? "All Teams" : a.team),
          onClickRow: () => {},
          columnClass: (a) => {
            return a.teamId == "*" ? "table-cell-highlighted" : "";
          },
          cellTemplate: (a) => {
            return a.teamId == "*" ? "All Teams" : a.team;
          },
        },
        {
          name: "expiredDate",
          displayName: "Expired Date",
          visible: true,
          type: "string",
          isEditable: false,
        },
      ];
      this.tableProps.columns = columns;
    },
    closeDialog(isSaved) {
      if (isSaved) {
        let data = {
          expiresAt: this.selectedDate ? new Date(this.selectedDate) : null,
          userId: this.selectedUser.id,
        };
        if (this.allTeams) {
          data["teamId"] = "*";
        } else {
          data["teamId"] = this.selectedTeam.id;
        }
        this.$store.dispatch("createUserTeamAssignments", data);
        this.getUsers();
        this.$forceUpdate();
      }
      this.$refs.createDialog.close();
    },
    openCreateDialog() {
      this.isNew = true;
      this.team = {
        organization: null,
        organizationName: null,
        user: null,
        userId: null,
        userEmail: null,
        organizationId: null,
      };
      this.$refs.createDialog.open();
    },
    openUpdateDialog(row, columns) {
      if (row) {
        this.selectedDate = row.expiresAt;
        this.user = Object.assign({}, row);
      } else {
        this.user = null;
      }
      this.$refs.updateDialog.open();
    },
    closeUpdateDialog(isSaved) {
      if (isSaved) {
        let data = {
          expiresAt: new Date(this.selectedDate),
          id: this.user.id,
          userId: this.user.userId,
          teamId: this.user.teamId,
        };

        if (!this.selectedDate) {
          data.expiresAt = null;
        }
        this.$store.dispatch("updateUserTeamAssignments", data);
        this.getUsers();
        this.$forceUpdate();
      }
      this.$refs.updateDialog.close();
      this.user = null;
    },
    openConfirmDialog(row) {
      this.user = row;
      if (this.user && this.user.team) {
        this.$refs.confirmDialog.open();
      } else {
        this.$refs.confirmEmptyDialog.open();
      }
    },
    closeConfirmDialog(isConfirmed) {
      if (isConfirmed) {
        this.$store
          .dispatch("deleteUserTeamAssignments", this.user.id)
          .then(() => {
            this.getUsers();
          });
      }
      this.$refs.confirmDialog.close();
    },
    closeConfirmEmptyDialog(val) {
      if (val) {
        this.openUpdateDialog(this.user);
      }
      this.$refs.confirmEmptyDialog.close();
    },
  },
  mounted() {
    this.$store.dispatch("getTeams");
    this.getUsers();
  },
};
</script>
<style>
.teams-list {
  margin: 20px 0;
}
.teams-list p {
  font-size: 14px;
  color: #868686;
  margin: 3px 0;
}
.table-cell-highlighted {
  color: #da7e2e;
  font-weight: bolder;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.md-input-container .md-error {
  display: block !important;
  left: 0;
  bottom: -30px;
  color: red;
  opacity: 1;
  transform: translate3d(0, -8px, 0);
  transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);
}
.all-teams-checkbox {
  font-size: 14px;
  margin-bottom: 0px;
  margin-left: 5px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// AdminUsersTeam.vue?035e83a5